import { SubscriptionStatus } from "./enum/SubscriptionStatus";
import { SubscriptionPaidRow } from "./row/SubscriptionPaidRow";
import { SubscriptionRow } from "./row/SubscriptionRow";

export class SubscriptionValidation
{
    public user_id: string;
    public sales_item_id: string;
    public date: Date = new Date();
    public subscribed: boolean;
    public valid: boolean;
    public valid_row: SubscriptionPaidRow | null;
    public valid_date: Date | null;
    public subscriptions: SubscriptionRow[] | null;
    public subscription_paids: SubscriptionPaidRow[] | null;
    constructor(user_id: string, sales_item_id: string, subscriptions: SubscriptionRow[] | null, subscription_paids: SubscriptionPaidRow[] | null)
    {
        this.user_id = user_id;
        this.sales_item_id = sales_item_id;
        this.subscriptions = subscriptions;
        this.subscription_paids = subscription_paids;
        if (subscription_paids)
            for (let i = 0; i < subscription_paids.length; i++)
            {
                const row = subscription_paids[i];
                row.applies_at = new Date(row.applies_at);
                row.expires_at = new Date(row.expires_at);
            }
        this.subscribed = SubscriptionValidation.isSubscribed(this, null);
        this.valid = SubscriptionValidation.isValid(this, this.date);
        this.valid_row = SubscriptionValidation.getValid(this, this.date);
        this.valid_date = SubscriptionValidation.getValidDateTo(this, this.date);
    }
    static isSubscribed(validation: SubscriptionValidation, offer_id: string | null)
    {
        let s = (validation.subscriptions ?? []).filter(s => s.status === SubscriptionStatus.Active).filter(s => offer_id == null || s.offer_id == offer_id);
        return s.length > 0;
    }
    static isValid(validation: SubscriptionValidation, now: Date | null = null)
    {
        return SubscriptionValidation.getValid(validation, now) != null;
    }
    static getValid(validation: SubscriptionValidation, now: Date | null = null): SubscriptionPaidRow | null
    {
        if (now == null)
            now = new Date();
        if (validation.subscription_paids)
            for (let i = 0; i < validation.subscription_paids.length; i++)
            {
                const row = validation.subscription_paids[i];
                if (row.applies_at <= now)
                    if (now <= row.expires_at)
                        return row;
            }
        return null;
    }
    static getValidDateTo(validation: SubscriptionValidation, now: Date | null = null): Date | null
    {
        let row = SubscriptionValidation.getValid(validation, now);
        if (row)
            return row.expires_at;
        return null;
    }
}